export default "__VITE_ASSET__8f6c9d4a__"